import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {
  RequestHeadCountDto,
  RequestReportSendEmailExcelDto,
  RequestReportSendEmailPdfDto, ResponseSendMailDto
} from "../dto/head-count-report.dto";
import {Observable} from "rxjs";

@Injectable()
export class HeadCountReportApi {
  private service: string = '';
  private model: string = 'HeadcountReport';
  private timeout: number = (5 * 60) * 1000;
  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  downloadExcel(data: RequestHeadCountDto){
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: RequestHeadCountDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  downloadPdf(data: RequestHeadCountDto){
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: RequestHeadCountDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  reportSendEmailExcel(data: RequestReportSendEmailExcelDto):Observable<ResponseSendMailDto>{
    const method: string = 'POST';
    const func: string = 'reportSendEmailExcel';
    const params: RequestReportSendEmailExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSendMailDto>(method, url, params, urlParams, body, null, this.timeout);
  }

  reportSendEmailPdf(data: RequestReportSendEmailPdfDto):Observable<ResponseSendMailDto>{
    const method: string = 'POST';
    const func: string = 'reportSendEmailPdf';
    const params: RequestReportSendEmailPdfDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSendMailDto>(method, url, params, urlParams, body, null, this.timeout);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/head-count-report.api.ts